export default "__VITE_ASSET__DpKEBe2P__"